import { Theme } from '@mui/material';

const CUBIC_BEZIER_TRANSITION = '1.000, 0.000, 0.000, 1.000';
const Button = (theme: Theme) => {
  return {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      variants: [
        {
          props: {
            variant: 'secondary',
          },
          style: {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.common.white,
            '&:hover': {
              backgroundColor: theme.palette.secondary.main,
              filter: 'brightness(0.85)',
            },
          },
        },
        {
          props: {
            variant: 'darkGrey',
          },
          style: {
            backgroundColor: theme.palette.darkGrey.main,
            color: theme.palette.grey[80],
            '&:hover': {
              backgroundColor: theme.palette.darkGrey.main,
              filter: 'brightness(0.85)',
            },
          },
        },
        {
          props: {
            variant: 'lightGrey',
          },
          style: {
            backgroundColor: theme.palette.lightGrey.main,
            color: theme.palette.grey[80],
            '&:hover': {
              backgroundColor: theme.palette.lightGrey.main,
              filter: 'brightness(0.85)',
            },
          },
        },
        {
          props: {
            variant: 'outlined',
          },
          style: {
            fontFamily: theme.palette.typography.font.bold,
            position: 'relative',
            overflow: 'hidden',
            zIndex: '20',
            transition: `all 0.35s cubic-bezier(${CUBIC_BEZIER_TRANSITION})`,
            '&:hover': {
              backgroundColor: theme.palette.action.hover,
            },
            '&:active': {
              backgroundColor: theme.palette.action.active,
            },
            ':hover': {
              color: 'white',
              ':after': {
                width: '100%',
              },
            },
            '&::before': {
              backgroundColor: theme.palette.primary.main,
              content: '""',
              position: 'absolute',
              zIndex: '-1',
              transition: `all 0.5s cubic-bezier(${CUBIC_BEZIER_TRANSITION})`,
            },
            '&::after': {
              backgroundColor: theme.palette.primary.main,
              content: '""',
              position: 'absolute',
              zIndex: '-1',
              transition: `all 0.5s cubic-bezier(${CUBIC_BEZIER_TRANSITION})`,
              height: '100%',
              width: 0,
              top: 0,
              left: 0,
            },
          },
        },
      ],
      styleOverrides: {
        root: {
          textTransform: 'none',
          boxShadow: 'none',
          paddingTop: '12px',
          paddingBottom: '12px',
          '&:hover': {
            boxShadow: 'none',
          },
          '&.MuiSwitch-switchBase': {
            backgroundColor: 'red',
            color: 'blue',
          },
          '.MuiSwitch-switchBase': {
            backgroundColor: 'red',
            color: 'blue',
          },
          '&.MuiSwitch-track': {
            backgroundColor: 'red',
            color: 'blue',
          },
          '.MuiSwitch-track': {
            backgroundColor: 'red',
            color: 'blue',
          },
        },
        contained: {
          fontFamily: theme.palette.typography.font.bold,
          '&.Mui-disabled': {
            color: theme.palette.common.white,
          },
          ':hover': {
            backgroundColor: theme.palette.buttonAction.hover,
          },
          ':active': {
            backgroundColor: theme.palette.buttonAction.active,
          },
        },
        text: {
          padding: 0,
          color: theme.palette.common.black,
          '&:hover': {
            backgroundColor: 'transparent',
            color: theme.palette.buttonAction.hover,
          },
          ':active': {
            backgroundColor: 'transparent',
            color: theme.palette.buttonAction.active,
          },
        },
      },
    },
  };
};
export default Button;
